<template>
  <div id="addVehicleDialog">
    <el-dialog
      title="新建考勤"
      :visible.sync="show"
      :close-on-press-escape="false"
      @closed="reset"
    >
      <el-form
        :model="addForm"
        :rules="addFormRules"
        ref="addForm"
        label-width="145px"
      >
        <el-form-item label="商户名称" prop="plateNum">
          <el-input
            v-model="addForm.plateNum"
            placeholder="请输入商户名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="商户类型" prop="vehicleSize">
          <el-select v-model="addForm.vehicleSize" placeholder="请选择商户类型">
            <el-option label="玩具店" value="玩具店"></el-option>
            <el-option label="零食店" value="零食店"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="备注">
          <el-input
            type="textarea"
            :rows="2"
            v-model="addForm.vehicleColor"
            placeholder="请输入备注"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="medium" @click="show = false">取 消</el-button>
        <el-button
          type="primary"
          size="medium"
          @click="confirmBtn"
          :loading="loading"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: ["getList"],
  data() {
    return {
      show: false,
      loading: false,
      addForm: {
        plateNum: "",
        vehicleSize: "小型车",
        vehicleBrand: "",
        vehicleColor: "",
      },
      addFormRules: {
        plateNum: [
          { required: true, message: "请输入商户名称", trigger: "blur" },
        ],
        vehicleSize: [
          { required: true, message: "请选择商户类型", trigger: "change" },
        ],
      },
    };
  },
  methods: {
    reset() {
      this.$set(this, "addForm", {
        plateNum: "",
        vehicleSize: "小型车",
        vehicleBrand: "",
        vehicleColor: "",
      });
    },
    async confirmBtn() {
      let falg = true;
      this.$refs["addForm"].validate((valid) => {
        if (!valid) {
          falg = false;
        }
      });
      if (!falg) {
        return;
      }
      try {
        this.loading = true;
        let res = await this.$http.post("/vehicle/add", {
          ...this.addForm,
        });
        if (res.code === 0) {
          this.getList();
          this.$message.success("添加成功");
          this.show = false;
        } else {
          this.$message.error(res.msg);
        }
      } catch (err) {
        this.$message.error(err);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
<style lang="scss">
#addVehicleDialog {
  .el-dialog__wrapper {
    .el-dialog {
      width: 500px;
      .el-dialog__header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 15px;
        border: 1px solid rgba(20, 34, 57, 0.13);
        .el-dialog__title {
          font-size: 14px;
          color: #142239;
          position: relative;
          z-index: 2;
          font-weight: bold;
          &::after {
            content: "";
            display: inline-block;
            width: 100%;
            height: 3px;
            background-color: $main-color;
            position: absolute;
            left: 0;
            bottom: 4px;
            z-index: -1;
          }
        }
        .el-dialog__headerbtn {
          position: initial;
          i {
            color: black;
          }
        }
      }
      .el-dialog__body {
        padding: 15px;
        .el-select {
          width: 100%;
        }
      }
      .el-dialog__footer {
        text-align: center;
        .dialog-footer {
          .el-button--default {
            border-color: $main-color;
            color: $main-color;
          }
        }
      }
    }
  }
}
</style>